import React, { useEffect, useState } from 'react';
import BankListTable from '../component/bank/BankListTable';
import CreateBankModal from '../component/bank/CreateBankModal';
import { BankResponse } from '../model/Bank.model';
import BankService from '../service/bank-service/Bank.service';
import { Spinner } from '@radix-ui/themes';
import { toast } from 'react-toastify'; // Import toast
import { Input, Row, Col, Space } from 'antd';

const BankPage: React.FC = () => {
  const [bankList, setBankList] = useState<BankResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(false); // Trạng thái loading
  const [searchTerm, setSearchTerm] = useState('');

  const fetchBankList = async () => {
    setLoading(true); // Bắt đầu loading
    try {
      const data = await BankService.getBankList();
      setBankList(data);
    } catch (error) {
      toast.error('Failed to fetch banks'); // Show error toast
    } finally {
      setLoading(false); // Dữ liệu đã được tải xong
    }
  };

  useEffect(() => {
    fetchBankList();
  }, []);

  const filteredBanks = bankList.filter((bank) =>
    bank.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="p-2 sm:p-4 max-h-screen">
      <Row gutter={[16, 16]} className="mb-4">
        <Col
          xs={24}
          sm={12}
          md={12}
          className="flex flex-col sm:flex-row gap-2"
        >
          <Space className="w-full sm:w-auto">
            <CreateBankModal onSuccess={fetchBankList} />
            {/* <ExportBanksButton className="w-full sm:w-auto" /> */}
          </Space>
        </Col>
        <Col xs={24} sm={12} md={12}>
          <Input
            placeholder="Tìm theo tên ngân hàng"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full"
          />
        </Col>
      </Row>
      {loading ? (
        <div className="flex justify-center items-center h-64">
          {' '}
          {/* Cài đặt kích thước cho phần loading */}
          <Spinner /> {/* Spinner */}
        </div>
      ) : (
        <div className="overflow-x-auto">
          <BankListTable bankList={filteredBanks} onSuccess={fetchBankList} />
        </div>
      )}
    </div>
  );
};

export default BankPage;
